/* eslint-disable no-empty */
/* eslint-disable default-case */
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

import { ThemeProvider as SCThemeProvider } from 'styled-components';

import { ThemeTypes } from '../types/theme-types';
import {
  darkDynamicColors,
  lightDynamicColors,
  staticColors,
} from '../styles/theme';
import { IFCWithChildren } from '../interfaces/i-fc-with-childrent';
import { IDynamicThemeColors } from '../interfaces/i-dynamic-theme-colors';

interface ICurrentThemeContextData {
  type: ThemeTypes;
  switchThemeType: () => void;
}

const CurrentThemeContext = createContext({} as ICurrentThemeContextData);

const CurrentThemeProvider: IFCWithChildren = ({ children }) => {
  const [type, setType] = useState<ThemeTypes>('dark');

  const switchThemeType = useCallback(() => {
    setType((prev) => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  const dynamicThemeColors = useMemo((): IDynamicThemeColors => {
    switch (type) {
      case 'dark': {
        return darkDynamicColors;
      }

      case 'light': {
        return lightDynamicColors;
      }
    }
  }, [type]);

  return (
    <CurrentThemeContext.Provider
      value={{
        type,
        switchThemeType,
      }}
    >
      <SCThemeProvider
        theme={{
          ...dynamicThemeColors,
          ...staticColors,
          primary:
            type === 'dark'
              ? darkDynamicColors.primary
              : lightDynamicColors.primary,
        }}
      >
        {children}
      </SCThemeProvider>
    </CurrentThemeContext.Provider>
  );
};

const useCurrentTheme = (): ICurrentThemeContextData => {
  return useContext(CurrentThemeContext);
};

export { CurrentThemeProvider, useCurrentTheme };
